import React, { memo } from 'react';
import classnames from 'classnames';
import { getDateText } from '@gp/components/DataTime/utils';
import '@gp/components/DataTime/index.scss';

const DataTime: React.FC<IDataTimeProps> = (props) => {
  const {
    dateType = 'Day',
    date,
    label = 'Data Time',
    align = 'left',
    placeholder = '-',
    className,
    style,
  } = props;

  const dateText = getDateText(dateType, date, placeholder);

  return (
    <div
      style={style}
      className={classnames('dbg-common-data-time', className, {
        'dbg-common-data-time-left': align === 'left',
        'dbg-common-data-time-right': align === 'right',
      })}
    >
      {label}: {dateText}
    </div>
  );
};

export default memo(DataTime);
